module.exports = __webpack_public_path__ + "static/media/September_2026_1.bc7d5d3c.webp";